import { createAction } from "redux-starter-kit";
import { normalize } from "normalizr";
import { addEntities } from "../../entities";

import {
  FETCH_NOTES_SUCCESS,
  FETCH_NOTES_REQUEST,
  FETCH_NOTES_FAILURE
} from "../types";

const fetchNotes = id => async (dispatch, getState, { api, schema }) => {
  try {
    dispatch(
      createAction(FETCH_NOTES_REQUEST)({
        id
      })
    );
    const response = await api.payments.getPaymentProfileNotes(id);
    const data = normalize(response, [schema.paymentBillingNotes]);
    dispatch(addEntities(data.entities));
    dispatch(createAction(FETCH_NOTES_SUCCESS)({ [id]: data.result }));
    return response;
  } catch (err) {
    dispatch(createAction(FETCH_NOTES_FAILURE)(err));
    throw err;
  }
};

export default fetchNotes;
